import React, { useState, useRef, useEffect, Ref } from 'react';
import { useReactToPrint } from 'react-to-print';
import { httpGet } from '../../../modules/Backend';
import { getCurrentFormattedDate } from '../../../helpers/DateHelper';
import LoadingButton from '../LoadingButton';
import { formatAddressParts } from '../../../helpers/StringHelper';

interface PrintableComponentProps {
  data: any;
  ref: React.RefObject<HTMLDivElement>
}

// Printable component with a ref to allow printing
const PrintableComponent = React.forwardRef<HTMLDivElement, PrintableComponentProps>(({ data }, ref) => (

  <div ref={ref}>
    {data && <div className='print-pick-list__wrapper'>
      <div className='print-pick-list__header'>
        <p>{getCurrentFormattedDate()}</p>
      </div>
      <div className='print-pick-list__information'>
        <h1>Return</h1>
        <h1>{data.accountName}</h1>
        <h1>{data.accountReference}</h1>
        <div>
          <h2>Our Ref: {data.reference}</h2>
        </div>
        <h2>Added On: {data.addedOn}</h2>
        <h2>Requested By: {data.requestedBy}</h2>
        <h2>Contact Number: {data.ContactNumber}</h2>
        <p className='p--bold'>Deliver to</p>
        <p>{formatAddressParts(data.deliveryAddress).join(", ")}</p>
      </div>
      {data && data.items.map((item: any, i: number) => (
        <>
          <div className='print-pick-list__item-wrapper'>
            <div className='print-pack-list__item-information-wrapper'>
              <div className='grid-x'>
                <p className='small-3'>Case</p>
                <p className='small-3'>{item.caseReference}</p>
                <p className='small-3'>Specimen</p>
                <p className='small-3'>{item.specimenReference}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Year</p>
                <p className='small-3'>{item.year}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Type</p>
                <p className='small-3'>{item.type}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Quantity</p>
                <p className='small-3'>{item.quantity}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Range</p>
                <p className='small-3'>{item.range}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Notes</p>
                <p className='small-3'>{item.itemNotes}</p>
              </div>
              <div className='grid-x'>
                <p className='small-3'>Range Notes</p>
                <p className='small-3'>{item.rangeNotes}</p>
              </div>
            </div>
          </div>
        </>
      ))
      }
    </div>}
  </div >
)
);

interface PrinterProps {
  returnId: string
}

function PrintReturn({ returnId }: PrinterProps) {
  const [data, setData] = useState<any[]>();
  const [shouldPrint, setShouldPrint] = useState(false);
  const [loading, setLoading] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);

  const fetchData = async () => {
    const response = await httpGet(`api/returns/printData?returnId=${returnId}`);
    if (response.data) {
      setData(response.data);
      setShouldPrint(true);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => { setShouldPrint(false); setLoading(false) }
  });

  useEffect(() => {
    if (shouldPrint && componentRef.current) {
      handlePrint();
    }
  }, [shouldPrint]);

  const handleFetchAndPrint = async () => {
    if (loading)
      return
    setLoading(true)
    fetchData()
  };

  return (
    <div>
      <LoadingButton className="button button--primary button--with-icon button--small"
        onPress={handleFetchAndPrint}
        isDisabled={loading}
        isLoading={loading}
        loadingText="Preparing"
        buttonText="Print packing sheet">
        <></>
      </LoadingButton>
      <div style={{ display: 'none' }}>
        {data && <PrintableComponent ref={componentRef} data={data} />}
      </div>
    </div>
  );
};

export default PrintReturn;